import { render, staticRenderFns } from "./trimHandleRight.vue?vue&type=template&id=b8479178&"
import script from "./trimHandleRight.vue?vue&type=script&lang=ts&"
export * from "./trimHandleRight.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports